module.exports = __webpack_public_path__ + "img/group_fill.e11a9978.png";